export default __webpack_public_path__ + "static/media/sales-white-db.6eed24fc.svg";